import { MenuOption } from 'components/common/DropdownList'
import { history, routePath } from 'routes'
import { Props } from './index'

export const AccountOptions = (props: Props): MenuOption[] => {
  return [
    {
      text: 'Edit Account',
      onClick: () => history.push(routePath.PROFILE)
    },
    {
      text: 'Logout',
      onClick: () => props.logout()
    }
  ]
}

export default AccountOptions
